module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_7",
    attrs: {
      "id": "calibre_pb_4"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc151366858"
    }
  }, [_vm._v("My Wish")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("My book of poems is about me and all of us—the quick, the dead, and generations to come.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It holds poems about us, living the life that we lead and envisioning the one we can potentially create.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It’s filled with poems about realising our dreams and inspiring others to pursue theirs, too.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It’s a collection of verses about a world imbued with peace, enchantment, and fulfilment for everyone.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("You’ll find poems defying the constraints and myths that seek to hold us down.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It contains words about evolving through time while remaining discerning and mighty.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It pays tribute and honour to the successes and victories of humanity through poignant poems.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("It lets imaginations and aspirations travel to worlds beyond, sowing seeds for the advancement of this generation.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Finally, it’s about fantasies and dreams—for it’s from these that we cultivate our minds to augment logic and inaugurate novelty.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b8ead4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 75
// module chunks = 0